export default {
  path: "/main/analysis/dashboard",
  name: "Dashboard",
  component: () => import("@/views/main/Analysis/dashboard/dashboard.vue"),
  children: []
};
